import * as OfferCard from './components/OfferCard.css';
export default {
    OfferCard
};
